import { postSse } from '../sse';

import { apiClient } from './axios';

import type { ChatListResponse, ChatMessagesResponse, SSEEvent } from '@repo/shared-types';

export async function streamChatMessage(
  message: string,
  chatId: string | undefined,
  onEvent: (event: SSEEvent) => void,
  signal?: AbortSignal,
): Promise<void> {
  return postSse<SSEEvent>(
    '/chats/send-message-stream',
    { message, chat_id: chatId },
    onEvent,
    signal,
  );
}

export async function getChatMessages(chatId: string): Promise<ChatMessagesResponse> {
  const response = await apiClient.get<ChatMessagesResponse>(`/chats/${chatId}/messages`);
  return response.data;
}

export async function listChats(page = 1, limit = 20): Promise<ChatListResponse> {
  const response = await apiClient.get<ChatListResponse>('/chats', { params: { page, limit } });
  return response.data;
}

export async function deleteChat(chatId: string): Promise<void> {
  await apiClient.delete(`/chats/${chatId}`);
}
